import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from '@/shared/shared.types';
import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C32IconCTAColoredBoxProps = RenderingProps<
  C32IconCTAColoredBoxFields,
  C32IconCtaColoredBoxRenderingParams
>;

export type C32IconCtaColoredBoxRenderingParams = {
  HeadlineType?: string;
  HeadlineAlignment?: string;
  SupportCopyAlignment?: string;
  NumberOfColumns?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C32IconCTAColoredBoxFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
};
